import React, { useState } from 'react';
import API from '../../ApiService/ApiService';
import Context from './index';
import Widget from '../../Helpers/Widget';


const CategoryMasterProvider = (props) => {
  const api = new API();
  const [fetchCategoryMasterList, setFetchCategoryMasterContextList] = useState([]);
  const [tableFilter, setTableFilter] = useState({
    name: '',
    _id: null,
    page: 1,
    limit: 20
  });
  const [loader,setLoader] = useState(false);
  const [deleteCategoryLoader, setDeleteCategoryLoader] = useState(false);
  
  const fetchCategoryMasterContext = async (id=null) => {
    if(id!="" && id!=null) {
      setTableFilter({
        ...tableFilter,
        _id: id
      })
    }
    setLoader(true);
    localStorage.getItem("rxdx_admin_login") === "true" &&
      (await api.getAll("categorymaster", { ...tableFilter,_id:id }, (err, res) => {
        setLoader(false);
        if (res?.data?.status === 200) {
          setFetchCategoryMasterContextList(res?.data?.data);
        } else {
          setFetchCategoryMasterContextList([]);
        }
      }));
  };

  const deleteCategory = async (id,fetchSubCategoryMasterContext) => {
    setDeleteCategoryLoader(true);
    localStorage.getItem("rxdx_admin_login") === "true" &&
      (await api.remove("categorymaster/deletecategory", id, (err, res) => {
        if (res?.data?.status === 200) {
          fetchCategoryMasterContext();
          fetchSubCategoryMasterContext && fetchSubCategoryMasterContext();
        }
        setDeleteCategoryLoader(false);
      }));
  };
  const updateOrdersHides = async (id, data) => {
    // console.log(tableSetting);
    localStorage.getItem("rxdx_admin_login") === "true" &&
      (await api.update(
        "categorymaster/updateordershides",
        id,
        {
          menu_order: data.menu_order,
          hide_website: data.hide_website,
        },
        (err, res) => {
          if (res?.data?.status === 200) {
            Widget.showMessage("success", res?.data?.message);
            return;
          }
        }
      ));
  };


   return (
    <Context.Provider value={{
      ...props,
       fetchCategoryMasterList,
       fetchCategoryMasterContext,
       tableFilter,
       setTableFilter,
        loader,
        deleteCategory,
        deleteCategoryLoader,
        
        updateOrdersHides,
    }}>
      {props.children}
    </Context.Provider>
   ) 
};

export default CategoryMasterProvider;
